<div class="install-body">
    <app-tabs [tabs]="tabs" class="tabs"></app-tabs>
    <div class="tab-content">
        <router-outlet></router-outlet>
    </div>
</div>
